import { CommonAction } from '@/actions/common/common';
import {Button, ButtonStyle, Checkbox, clearSWRCache, ClientDashboard, Field, Form, Formik, FormikControl, getMyPreferencesData, handleFormSubmit,
        handelChecked, handleDisableValueChange, INITIAL_VALUES,  InputError, PageStyle,  reset_the_initial_values, Table, TableBody,
        TableCell, TableContainer, TableHead,  TableRow, TIMEINTERVAL, useRouter, useState, useTranslation, useSWR, VALIDATION_SCHEMA,
        WEEKDAYS, useEffect, useQueryClient, useRef, motion, PAGE_ANIMATION_OPTIONS, ErrorPages, SkipModal, SidebarAction, getSession, QuickAdd, MyPreferencesAction, CopyIcon } from '@/imports-files/pages/clients/my-preferences';
        
function MyPreferences(props)
{
    clearSWRCache('my-preference-data')
    const [apiError, setApiError]               =   useState(null);
    const errorPages                            =   new ErrorPages();
    const router                                =   useRouter();
    const { t, i18n }                           =   useTranslation();
    const { data, error }                       =   useSWR('my-preference-data', () => { return getMyPreferencesData(router, setApiError)});
    const [initial_values, setInitialValue ]    =   useState(INITIAL_VALUES);
    const [ isLoading, setLoading]              =   useState(true);
    const [pageLoaded, setPageLoaded]           =   useState(false);
    const formRef                               =   useRef(null);
    const queryClient                           =   useQueryClient();
    const step                                  =   router.query.step;
    const isQuickSetup                          =   router.query.step && (router.query.step == 'my_preferences') ? true : false
    const [skipModal, setSkipModal]             =   useState(false);
    const [session, setSession]                 =   useState(props.session);
    const common_action                         =   new CommonAction();
    const [timezonOptions, setTimezoneOptions]  =   useState([])
    const [dateOptions, setDateOptions]  =   useState([])
    const [timePicker, setTimePicker] = useState([]);
    const myPreferencesAction = new MyPreferencesAction(setTimePicker);
    const[dateEx7,setDateEx7]= useState("10:12")


    useEffect(() => {

                        if(data)
                        {
                          if(!pageLoaded)
                          {
                            let values = reset_the_initial_values(data, INITIAL_VALUES, "page")
                            setTimezoneOptions(data.timezones)
                            setInitialValue(values);
                            setDateOptions(data.date_formats)
                            setPageLoaded(true)
                          }

                          if(isQuickSetup)
                           setTimeout(() => {
                            new SidebarAction().subsidebarQuickSetupChangeIcon(data.sidebar_options.complete_steps, 'my_preferences');
                         }, 750);
                          setLoading(false);
                        }
                    },[data])


  if(isLoading || error || errorPages.handleErrorCodes(apiError?.status))
  {
    var renderPage  =  (error || apiError) ? errorPages.renderPage(error?.status || apiError?.status, router) : null;
    return renderPage;
  }


    function CustomCheckbox({field, onChange, checked})
    {
      return <Checkbox  onChange    =   {onChange}
                        name        =   {field.name}
                        checked     =   {checked}/>
    }

    return (
        <div className={`Page DashboardPageContent MyPreferencesPage  ${PageStyle.MyPreferences} ${PageStyle.NoMaxGrid}`}>
           <motion.div initial="pageInitial"  animate="pageAnimate"  exit="pageExit"  variants={PAGE_ANIMATION_OPTIONS}  transition={{ delay: 0.2}}>

            <div className={PageStyle.MyPreferences__Container}>

            { session?.role != 'reviewer' &&  <div className={PageStyle.MyPreferences__TopSection}>
              <div className={PageStyle.JobList__QuickAdd}>
                <QuickAdd session={session}/>
              </div>
            </div>}

              <div className={PageStyle.MyPreferences__FormSection}>
                <h1 className={`mt0 ${PageStyle.MyPreferences__Heading}`}>{t('page:clients:my-preferences:texts:title')}</h1>
                <div>
                  <div className={PageStyle.MyPreferences__Subheading}>
                    {/* <div className={`mt0 ${PageStyle.MyPreferences__Subheading_1}`}> {t('page:clients:my-preferences:texts:subtitle_1')}</div> */}
                    {t('page:clients:my-preferences:texts:subtitle')}</div>
                </div>
              </div>

              <Formik
                          initialValues     = {initial_values}
                          validationSchema  = {VALIDATION_SCHEMA}
                          onSubmit          =   { async (values, actions) =>  {
                                                                                  const errors = await handleFormSubmit(values, router, formRef, isQuickSetup, setApiError) ;
                                                                                  actions.setErrors(errors)
                                                                              }
                                                }
                          innerRef={formRef}
                        >
              {(formik) => (
                            <Form name="users">

                            <div className={PageStyle.Buffer}>
                              <h3>{t('page:clients:my-preferences:texts:date_format')}</h3>
                              <span>{t('page:clients:my-preferences:texts:date_format_description')}</span>
                              <div className={PageStyle.Buffer__BufferTimeGrid}>
                                <div className={PageStyle.Buffer__time}>
                                  <FormikControl className    =  {`${PageStyle.Form__Input}`}
                                    control      =  "select"
                                    errorClass   =  {PageStyle.Form__Error}
                                    formik       =  {formik}
                                    name         =  {`users.client_user_attributes.date_format`}
                                    onChange     =   {async(option) => {
                                        await formik.setFieldValue("users.client_user_attributes.date_format", option.value)
                                      }
                                    }
                                    options      =  {dateOptions}
                                    style        =  {InputError(formik, `users.client_user_attributes.date_format`)}
                                    default      =  { formik.values?.users.client_user_attributes.date_format }
                                  />
                                </div>
                              </div>
                            </div>

                            <div className={PageStyle.Buffer}>
                              <h3>{t('page:clients:my-preferences:texts:time_zone')}</h3>
                              <span>{t('page:clients:my-preferences:texts:time_zone_description')}</span>
                              <div className={PageStyle.Buffer__BufferTimeGrid}>
                                <div className={PageStyle.Buffer__time}>
                                  <FormikControl className    =  {`${PageStyle.Form__Input}`}
                                    control      =  "select"
                                    errorClass   =  {PageStyle.Form__Error}
                                    formik       =  {formik}
                                    name         =  {`users.client_user_attributes.timezone`}
                                    onChange     =   {async(option) => {
                                        // let old_time_zone = formik.values.users.client_user_attributes.timezone
                                        // await myPreferencesAction.changePreferenceTime(formik, old_time_zone, option.value)
                                        await formik.setFieldValue("users.client_user_attributes.timezone", option.value)
                                        
                                      }
                                    }
                                    options      =  {timezonOptions}
                                    style        =  {InputError(formik, `users.client_user_attributes.timezone`)}
                                    default      =  { formik.values?.users.client_user_attributes.timezone }
                                  />
                                </div>
                              </div>
                            </div>

                            <div className={PageStyle.IntegrationTable}>
                              <TableContainer>
                                <Table>
                                  <TableHead>
                                    <TableRow>
                                      <TableCell style={{ width: "26.6%" }}>{t('page:clients:my-preferences:texts:days')}</TableCell>
                                      <TableCell style={{ width: "26.6%" }}>{t('page:clients:my-preferences:texts:start')}</TableCell>
                                      <TableCell style={{ width: "26.6%" }}>{t('page:clients:my-preferences:texts:end')}</TableCell>
                                      <TableCell style={{ width: "20%" }}>{}</TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody>

                                    { WEEKDAYS.map((row, id) => (
                                                                    <TableRow key={id}>

                                                                      <TableCell style={{display: "flex", alignItems: "center", marginTop: "10px"}}>
                                                                        <input className = "isDisable" type="hidden" onInput={ () => { handleDisableValueChange(formik, `users.preferences_attributes[${id}].isDisabled`)}}  name = {`users.preferences_attributes[${id}].isDisabled`} />
                                                                        <Field  component   =   {CustomCheckbox}
                                                                                onChange    =   {(element) => handelChecked(element, formik, id)}
                                                                                name        =   {`users.preferences_attributes[${id}].weekday`}
                                                                                checked     =   { formik.values.users.preferences_attributes[id]?.isDisabled != undefined ?
                                                                                                  (formik.values.users.preferences_attributes[id].isDisabled ? false : true) :
                                                                                                  false
                                                                                                }
                                                                        />
                                                                        {row.day}
                                                                      </TableCell>

                                                                      <TableCell align="right">
                                                                          <FormikControl  control      =  {"timeinput"}
                                                                            disabled     =  {formik.values?.users?.preferences_attributes[id]?.isDisabled}
                                                                            value        =  {formik.values.users.preferences_attributes[id]?.start_time}
                                                                            fullTimeDropdown = {!formik.values?.users?.preferences_attributes[id]?.isDisabled}
                                                                            allowDelete  =  {true}
                                                                            hour12Format =  {false}
                                                                            onChange  = {(dateString) => {
                                                                                formik.setFieldValue(`users.preferences_attributes[${id}].start_time`, dateString) 
                                                                              }
                                                                            }
                                                                            inputProps = {{
                                                                              style:  InputError(formik, `users.preferences_attributes[${id}].start_time`),
                                                                            }}
                                                                            errorClass   =  {PageStyle.Form__Error}
                                                                            name = {`users.preferences_attributes.${id}.start_time`}
                                                                            formik = {formik}
                                                                            manuallyDisplayDropdown={true}
                                                                          />
                                                                        
                                                                      </TableCell>

                                                                      <TableCell align="right">
                                                                        <FormikControl  control      =  {"timeinput"}
                                                                          disabled     =  {formik.values?.users?.preferences_attributes[id]?.isDisabled}
                                                                          value        =  {formik.values.users.preferences_attributes[id]?.end_time}
                                                                          fullTimeDropdown = {!formik.values?.users?.preferences_attributes[id]?.isDisabled}
                                                                          allowDelete  =  {true}
                                                                          hour12Format =  {false}
                                                                          onChange  = {(dateString) => {
                                                                              formik.setFieldValue(`users.preferences_attributes[${id}].end_time`, dateString) 
                                                                            }
                                                                          }
                                                                          inputProps = {{
                                                                              style:  InputError(formik, `users.preferences_attributes[${id}].end_time`),
                                                                          }}
                                                                          errorClass   =  {PageStyle.Form__Error}
                                                                          name = {`users.preferences_attributes.${id}.end_time`}
                                                                          formik = {formik}
                                                                        />
                                                                      </TableCell>
                                                                      <TableCell>{myPreferencesAction.showCopyOptionIndex(formik) != undefined && (myPreferencesAction.showCopyOptionIndex(formik) == id) &&  <div className={PageStyle.CopyTime}><Button onClick={() => myPreferencesAction.copyTime(formik, id)}><CopyIcon/> Copy time to all</Button></div>}</TableCell>

                                                                    </TableRow>
                                                                  ))
                                    }
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>


                            <div className={PageStyle.Buffer}>
                              <h3>{t('page:clients:my-preferences:texts:buffer_time')} <span>(In Minutes)</span></h3>
                              <span className="">{t('page:clients:my-preferences:texts:buffer_time_description')}</span>
                              <div className={PageStyle.Buffer__BufferTimeGrid}>
                                <div className={PageStyle.Buffer__time}>
                                  {/* <span>{t('page:clients:my-preferences:texts:before_interview')}</span> */}
                                  <FormikControl className    =  {`${PageStyle.Form__Input}`}
                                    control      =  "select"
                                    errorClass   =  {PageStyle.Form__Error}
                                    formik       =  {formik}
                                    name         =  {`users.client_user_attributes.buffer_before_interview`}
                                    onChange     =   {(option) => {
                                      formik.setFieldValue("users.client_user_attributes.buffer_before_interview", option.value)
                                      formik.setFieldValue("users.client_user_attributes.buffer_after_interview", option.value)
                                    }}
                                    options      =  {TIMEINTERVAL.options}
                                    style        =  {InputError(formik, `users.client_user_attributes.buffer_before_interview`)}
                                    default      =  { formik.values?.users.client_user_attributes.buffer_before_interview }
                                  />
                                </div>
                              </div>
                            </div>

                            <div className={PageStyle.space}></div>

                            {!isQuickSetup && <div className={PageStyle.MyPreferences__SubmitSection}>
                              <Button type="submit" buttonstyle={ButtonStyle.secondarybtn}>{t('page:clients:my-preferences:texts:save_changes')}</Button>
                            </div>}
                            {skipModal && <SkipModal setBtnPopup={setSkipModal} router={router}></SkipModal>}
                            {isQuickSetup && <div className={`buttonolumngap ${PageStyle.MyPreferences__SubmitSectionNext}`}>
                              <Button buttonstyle={ButtonStyle.secondarybtnborder} type="button" onClick={() => {
                                setSkipModal(true)}}> Skip </Button>
                              <Button buttonstyle={ButtonStyle.primarybtn} type="submit"> Next </Button>
                            </div>}
                      </Form>
              )}

              </Formik>

            </div>

          </motion.div>
        </div>
    );
}

MyPreferences.layout = ClientDashboard;
export default MyPreferences;
